import React, { useState } from 'react';
import Icon from '../../components/AppIcon';

const ACCENT = '#60A5FA';
const GOLD = '#D6EF4E';

const PendingBadge = () => (
  <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg"
    style={{ background: 'rgba(251,191,36,0.08)', border: '1px solid rgba(251,191,36,0.20)' }}>
    <div className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse" />
    <span className="font-oranienbaum text-amber-400 text-xs tracking-widest uppercase">Pendiente de conexión con Supabase</span>
  </div>
);

const kpis = [
  { label: 'Compras del Mes', value: '—', icon: 'ShoppingBag', color: ACCENT },
  { label: 'IVA Soportado', value: '—', icon: 'Receipt', color: '#A78BFA' },
  { label: 'Facturas Pendientes', value: '—', icon: 'Clock', color: '#FBBF24' },
  { label: 'Pendiente de Pago', value: '—', icon: 'AlertCircle', color: '#F87171' },
  { label: 'Coste Medio Compra', value: '—', icon: 'DollarSign', color: '#34D399' },
  { label: 'Variación Costes', value: '—', icon: 'TrendingUp', color: GOLD },
  { label: 'Proveedores Activos', value: '—', icon: 'Building2', color: '#38BDF8' },
];

const ocrSteps = [
  { step: 1, label: 'Subir PDF', icon: 'Upload', color: ACCENT },
  { step: 2, label: 'OCR', icon: 'ScanLine', color: '#A78BFA' },
  { step: 3, label: 'Revisión', icon: 'Eye', color: GOLD },
  { step: 4, label: 'Vincular Productos', icon: 'Link', color: '#34D399' },
  { step: 5, label: 'Confirmación', icon: 'CheckCircle', color: '#4ADE80' },
  { step: 6, label: 'Entrada Stock', icon: 'PackagePlus', color: '#38BDF8' },
  { step: 7, label: 'Contabilidad', icon: 'BookOpen', color: '#F472B6' },
];

const invoiceStatuses = ['Todos', 'Pendiente OCR', 'En Revisión', 'Confirmada', 'Pagada', 'Vencida', 'Con Incidencia'];
const pageSizes = [25, 50, 100];

const columns = [
  'Proveedor', 'Número', 'Fecha', 'Base Imponible', 'IVA', 'Total',
  'Vencimiento', 'Estado Pago', 'Documento', 'Estado OCR', 'Responsable'
];

const DistFacturasEntrantes = () => {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('Todos');
  const [pageSize, setPageSize] = useState(25);
  const [activeTab, setActiveTab] = useState('lista');
  const [dragOver, setDragOver] = useState(false);

  return (
    <div className="min-h-screen px-4 py-6 md:px-8"
      style={{ background: 'linear-gradient(135deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)' }}>
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <nav className="flex items-center gap-2 text-xs font-oranienbaum text-white/30 mb-2">
            <span>🚚 Distribución</span>
            <Icon name="ChevronRight" size={12} />
            <span className="text-white/60">Facturas Entrantes</span>
          </nav>
          <div className="flex items-center gap-3 mb-1">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center"
              style={{ background: `${ACCENT}15`, border: `1px solid ${ACCENT}30` }}>
              <Icon name="FileInput" size={18} style={{ color: ACCENT }} />
            </div>
            <h1 className="font-oranienbaum font-bold text-white text-2xl md:text-3xl tracking-wide">Facturas Entrantes</h1>
          </div>
          <p className="font-oranienbaum text-white/40 text-sm ml-12">Compras de distribución · Flujo OCR + Revisión humana</p>
        </div>
        <PendingBadge />
      </div>
      {/* KPIs */}
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3 mb-6">
        {kpis?.map((kpi, i) => (
          <div key={i} className="rounded-xl p-3 flex flex-col gap-1.5"
            style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <div className="w-7 h-7 rounded-lg flex items-center justify-center"
              style={{ background: `${kpi?.color}15`, border: `1px solid ${kpi?.color}25` }}>
              <Icon name={kpi?.icon} size={13} style={{ color: kpi?.color }} />
            </div>
            <p className="font-oranienbaum font-bold text-white text-lg">{kpi?.value}</p>
            <p className="font-oranienbaum text-white/45 text-[10px] leading-tight">{kpi?.label}</p>
          </div>
        ))}
      </div>
      {/* OCR Flow */}
      <div className="mb-6 p-5 rounded-2xl"
        style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
        <h3 className="font-oranienbaum font-semibold text-white/70 text-xs uppercase tracking-widest mb-4">Flujo de Procesamiento</h3>
        <div className="flex items-center gap-2 overflow-x-auto pb-2">
          {ocrSteps?.map((step, i) => (
            <React.Fragment key={step?.step}>
              <div className="flex flex-col items-center gap-2 min-w-[72px]">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ background: `${step?.color}15`, border: `1px solid ${step?.color}30` }}>
                  <Icon name={step?.icon} size={16} style={{ color: step?.color }} />
                </div>
                <div className="text-center">
                  <p className="font-oranienbaum text-[10px] font-bold" style={{ color: step?.color }}>{step?.step}</p>
                  <p className="font-oranienbaum text-white/45 text-[9px] leading-tight text-center">{step?.label}</p>
                </div>
              </div>
              {i < ocrSteps?.length - 1 && (
                <Icon name="ChevronRight" size={14} className="text-white/20 flex-shrink-0" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
      {/* Human confirmation warning */}
      <div className="mb-4 p-3 rounded-xl flex items-start gap-3"
        style={{ background: 'rgba(251,191,36,0.06)', border: '1px solid rgba(251,191,36,0.20)' }}>
        <Icon name="AlertTriangle" size={15} className="text-amber-400 flex-shrink-0 mt-0.5" />
        <p className="font-oranienbaum text-amber-400/80 text-xs leading-relaxed">
          <strong className="text-amber-400">Confirmación humana obligatoria:</strong> No se actualizará el inventario de distribución ni se contabilizará ninguna factura sin revisión y confirmación manual. El OCR es solo una ayuda.
        </p>
      </div>
      {/* Tabs */}
      <div className="flex gap-1 mb-4 p-1 rounded-xl w-fit"
        style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
        {[
          { key: 'lista', label: 'Lista de Facturas' },
          { key: 'subir', label: 'Subir Factura' },
        ]?.map(tab => (
          <button key={tab?.key} onClick={() => setActiveTab(tab?.key)}
            className="px-4 py-1.5 rounded-lg text-xs font-oranienbaum transition-all"
            style={activeTab === tab?.key
              ? { background: `${ACCENT}20`, color: ACCENT, border: `1px solid ${ACCENT}35` }
              : { color: 'rgba(255,255,255,0.40)', border: '1px solid transparent' }}>
            {tab?.label}
          </button>
        ))}
      </div>
      {activeTab === 'subir' ? (
        /* Upload Zone */
        (<div className="rounded-2xl p-8 flex flex-col items-center justify-center gap-4 transition-all"
          style={{
            background: dragOver ? `${ACCENT}08` : 'rgba(255,255,255,0.02)',
            border: `2px dashed ${dragOver ? ACCENT : 'rgba(255,255,255,0.12)'}`,
            minHeight: 280
          }}
          onDragOver={e => { e?.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={e => { e?.preventDefault(); setDragOver(false); }}>
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center"
            style={{ background: `${ACCENT}15`, border: `1px solid ${ACCENT}30` }}>
            <Icon name="Upload" size={28} style={{ color: ACCENT }} />
          </div>
          <div className="text-center">
            <p className="font-oranienbaum font-semibold text-white text-base mb-1">Arrastra tu factura PDF aquí</p>
            <p className="font-oranienbaum text-white/40 text-sm">o haz clic para seleccionar el archivo</p>
          </div>
          <button className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-oranienbaum transition-colors"
            style={{ background: `${ACCENT}20`, border: `1px solid ${ACCENT}40`, color: ACCENT }}>
            <Icon name="FolderOpen" size={15} />
            Seleccionar PDF
          </button>
          <p className="font-oranienbaum text-white/25 text-xs">PDF · Máx. 10 MB · El OCR procesará automáticamente el contenido</p>
        </div>)
      ) : (
        /* Invoice List */
        (<>
          <div className="flex flex-col sm:flex-row gap-3 mb-4">
            <div className="flex-1 relative">
              <Icon name="Search" size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
              <input
                value={search}
                onChange={e => setSearch(e?.target?.value)}
                placeholder="Buscar por proveedor, número, fecha..."
                className="w-full pl-9 pr-4 py-2.5 rounded-xl text-sm font-oranienbaum text-white/80 placeholder-white/25 outline-none"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)' }}
              />
            </div>
            <div className="flex gap-2 flex-wrap">
              <select value={statusFilter} onChange={e => setStatusFilter(e?.target?.value)}
                className="px-3 py-2.5 rounded-xl text-xs font-oranienbaum text-white/70 outline-none"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)' }}>
                {invoiceStatuses?.map(s => <option key={s} value={s} style={{ background: '#1A1A1A' }}>{s}</option>)}
              </select>
              <select value={pageSize} onChange={e => setPageSize(Number(e?.target?.value))}
                className="px-3 py-2.5 rounded-xl text-xs font-oranienbaum text-white/70 outline-none"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)' }}>
                {pageSizes?.map(s => <option key={s} value={s} style={{ background: '#1A1A1A' }}>{s} / pág</option>)}
              </select>
              <button className="flex items-center gap-1.5 px-3 py-2.5 rounded-xl text-xs font-oranienbaum text-white/60 hover:text-white/80 transition-colors"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)' }}>
                <Icon name="Download" size={13} />
                Exportar
              </button>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden"
            style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[900px]">
                <thead>
                  <tr style={{ background: 'rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                    <th className="px-3 py-3 text-left">
                      <input type="checkbox" className="w-3.5 h-3.5 rounded accent-[#60A5FA]" />
                    </th>
                    {columns?.map(col => (
                      <th key={col} className="px-3 py-3 text-left">
                        <button className="flex items-center gap-1 font-oranienbaum text-white/50 text-xs hover:text-white/80 transition-colors">
                          {col}
                          <Icon name="ChevronsUpDown" size={10} className="text-white/25" />
                        </button>
                      </th>
                    ))}
                    <th className="px-3 py-3 text-left">
                      <span className="font-oranienbaum text-white/50 text-xs">Acciones</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={columns?.length + 2} className="px-4 py-16 text-center">
                      <div className="flex flex-col items-center gap-3">
                        <div className="w-12 h-12 rounded-2xl flex items-center justify-center"
                          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                          <Icon name="FileInput" size={22} className="text-white/20" />
                        </div>
                        <p className="font-oranienbaum text-white/30 text-sm">Sin facturas registradas</p>
                        <p className="font-oranienbaum text-white/20 text-xs">Pendiente de conexión con Supabase</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="flex items-center justify-between px-4 py-3"
              style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
              <p className="font-oranienbaum text-white/35 text-xs">0 facturas · Página 1 de 1</p>
              <div className="flex items-center gap-1">
                {['ChevronLeft', 'ChevronRight']?.map((icon, i) => (
                  <button key={i} className="w-7 h-7 rounded-lg flex items-center justify-center text-white/30 hover:text-white/60 hover:bg-white/5 transition-colors">
                    <Icon name={icon} size={14} />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </>)
      )}
    </div>
  );
};

export default DistFacturasEntrantes;
